import type { ReactElement } from 'react'
import type { OptionProps } from 'react-select'

import './styles.scss'

const CustomLongTextOption = ({
  className,
  cx,
  data,
  innerProps,
  innerRef,
  isDisabled,
  isFocused,
  isSelected,
}: OptionProps): ReactElement => {
  const { label } = data as IOption

  return (
    <div
      className={cx(
        {
          option: true,
          'option--is-disabled': isDisabled,
          'option--is-focused': isFocused,
          'option--is-selected': isSelected,
          'option-long-text': true,
        },
        className
      )}
      ref={innerRef}
      {...innerProps}
    >
      <span className="react-select__option-long-text__label">{label}</span>
    </div>
  )
}

export default CustomLongTextOption
